import moment from 'moment';

export const FORMAT_DAY_MONTH_YEAR = 'DD/MM/YYYY';

export const formatDayDateMonthYear = date =>
  date && moment(date).isValid() ? moment(date).format(FORMAT_DAY_MONTH_YEAR) : '';
